// extracted by mini-css-extract-plugin
module.exports = {"container":"SortArrow_container__3mPWD","up":"SortArrow_up__2Ipz7"};